import type React from 'react';

// Icon
import IconCheckmarkWhite from 'images/icons/checkmark-white.svg';

// Misc / utils
import * as S from './styles';

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  className?: string;
  ariaLabel?: string;
  children?: React.ReactNode;
  flex?: boolean;
  isChecked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({
  className,
  ariaLabel,
  children,
  flex = false,
  isChecked,
  onChange,
  ...rest
}) => {
  return (
    <S.Label flex={flex} className={className}>
      <S.HiddenCheckbox type="checkbox" checked={isChecked} onChange={onChange} aria-label={ariaLabel} {...rest} />
      <S.StyledCheckbox checked={isChecked}>
        {isChecked && <img src={IconCheckmarkWhite} height="14px" width="14px" alt="" />}
      </S.StyledCheckbox>
      {children}
    </S.Label>
  );
};

export default Checkbox;
